export default __webpack_public_path__ + "cc7ee35ca49c83d4cfca932a03139f99.ttf";